export enum PermissionType {
  PROFILE_VIEW = "PROFILE_VIEW",
  USERS_AND_PROFILES = "USERS_AND_PROFILES",
  ROLES_AND_PERMISSIONS = "ROLES_AND_PERMISSIONS",
  SALES = "SALES",
  PURCHASES = "PURCHASES",
  MY_CASH_BOXES = "MY_CASH_BOXES",
  PROVIDERS = "PROVIDERS",
  CASH_BOXES = "CASH_BOXES",
  CLIENTS = "CLIENTS",
  SERVICE_ORDERS = "SERVICE_ORDERS",
  MY_SERVICE_ORDERS = "MY_SERVICE_ORDERS",
  LIQUIDATIONS = "LIQUIDATIONS",
  MY_LIQUIDATIONS = "MY_LIQUIDATIONS",
  ACCOUNTS = "ACCOUNTS",
  CATEGORIES = "CATEGORIES",
  TECHNIQUES = "TECHNIQUES",
  REVISION_ITEMS = "REVISION_ITEMS",
  MY_EVALUATIONS = "MY_EVALUATIONS",
}
